import { runIfConsentForFeatureEnabled } from '@otto-ec/eprivacy-shared'

void runIfConsentForFeatureEnabled(async () => {
  const { bootstrap } = await import('./core/bootstrap')
  return bootstrap()
})
